<template>
  <ul
    role="list"
    class="grid grid-cols-8 gap-x-6 flex-1 py-1 px-6 items-start gap-y-3 overflow-y-auto h-full"
  >
    <template
      v-for="file in files"
      :key="file.id"
    >
      <component
        :is="getGridItemComponent"
        v-if="file.blurhash || file.file"
        :file="file"
        :mid="file.id"
        :current-id="currentId"
        :new-file-ids="newFileIds"
        :multiple="multiple"
        @select="onSelect"
      />
      <li
        v-else
        class="flex items-center flex-col "
      >
        <div class="aspect-[4/3] rounded-md border w-full flex items-center justify-center ">
          <stormy-spinner
            :show="true"
            :size="4"
          />
        </div>
        <p class="pointer-events-none mt-2 w-full block truncate text-sm font-medium text-center text-gray-900">
          {{ file.org_name }}
        </p>
      </li>
    </template>
  </ul>
</template>
<script setup>
import { computed, toRefs } from 'vue'
import { useProp } from '@/composables/useProp.js'
import MediaGridItem from './MediaGridItem.vue'
import MediaGridItemSingleMode from './MediaGridItemSingleMode.vue'
import { useMediaStore } from '@/pinia/MediaStore'
import { storeToRefs } from 'pinia'

const mediaStore = useMediaStore()
const { mediaFiles, isLoading, newMediaFiles, currentItem, newFileIds } = storeToRefs(mediaStore)

const emit = defineEmits(['select'])

const getGridItemComponent = computed(() => props.multiple ? MediaGridItem : MediaGridItemSingleMode)

const props = defineProps({
  files: useProp(Array),
  uploaded: useProp(Array),
  loading: useProp(Boolean),
  currentId: useProp(Number),
  multiple: useProp(Boolean, false)
})

const onSelect = (id) => {
  mediaStore.setCurrentItem(id)
}

const { files } = toRefs(props)

</script>
